import { Stack } from "@mui/material";
import { HuntersPageContent } from "Components/Hunter/HuntersOverview/HuntersPageContent";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { DownloadInvoicesSection } from "Components/Shared/DownloadInvoicesSection/DownloadInvoicesSection";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { useIsCurrentUserAdmin } from "Hooks/useIsCurrentUserAdmin";
import { SettlementInvoiceType } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Pages.Titles;

export const HuntersPage = () => {
  const { t } = useResource();
  const isAdmin = useIsCurrentUserAdmin();

  return (
    <AuthenticatedLayout title={t(RESOURCES.Hunters)}>
      <StyledPageWrapper maxWidth="unset !important">
        <Stack gap={4}>
          {isAdmin && (
            <DownloadInvoicesSection
              invoiceType={SettlementInvoiceType.Hunter}
            />
          )}
          <HuntersPageContent />
        </Stack>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default HuntersPage;
